import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class HinarioProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  getHinos(pag: { currentPage: any }, filtro: any, idTipo: any) {
    return this.http
      .get<any>(this.baseUrl + "/hinario/get-hinos", {
        observe: "response",
        params: {
          page: pag.currentPage,
          "per-page": "10",
          f: filtro,
          idTipo: idTipo,
        },
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
            totalCount: data.headers.get("X-Pagination-Total-Count"),
          };
          return {
            hinos: data.body,
            pagination: pag,
          };
        })
      );
  }

  getHino(id: any) {
    return this.http
      .post<any>(this.baseUrl + "/hinario/get-hino", {
        id: id,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getTiposHinario() {
    return this.http.get<any>(this.baseUrl + "/hinario/tipos-hinario").pipe(map((data) => data));
  }

  getProximo(id: any) {
    return this.http
      .get<any>(`${this.baseUrl}/hinario/proximo-hino`, {
        params: { id: id.toString() },
      })
      .pipe(map((data) => data));
  }

  getAnterior(id: any) {
    return this.http
      .get<any>(`${this.baseUrl}/hinario/anterior-hino`, {
        params: { id: id.toString() },
      })
      .pipe(map((data) => data));
  }

  buscar(idHinario: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/hinario/favoritos-buscar`, {
      params: { idHinario },
    });
  }

  salvar(idHinario: number) {
    return this.http.post(`${this.baseUrl}/hinario/favoritos-salvar`,{},
      {params: { idHinario },}
    );
  }

  apagar(idHinario: number) {
    return this.http.delete(`${this.baseUrl}/hinario/favoritos-apagar`, {
      params: { idHinario },
    });
  }
}
